import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Alert, AlertTitle, AlertDescription } from '../ui/alert';
import { Button } from '../button';
import Icon from '../icon';

const ErrorComponent = ({ error, t }) => (
  <div className="AsyncSpinner">
    <div>
      <Alert variant="error">
        <Icon type="close_round__filled" />
        <AlertTitle>{t('core:template_error')}</AlertTitle>
        <AlertDescription>
          {error.type ? (
            <>
              <b>{error.type}</b>
              <br />
              {error.detail}
            </>
          ) : error.message}
        </AlertDescription>
      </Alert>
      <br />
      <br />
      <Button type="primary" size="large" onClick={() => window?.location?.reload?.()}>
        <Trans i18nKey="core:template_error_refresh_button" />
      </Button>
      <Button type="inverted-primary" size="large" onClick={() => window?.history?.back?.()}>
        <Trans i18nKey="core:template_error_back_button" />
      </Button>
      {process.env.INTERCOM_APP_ID && (
        <Button type="inverted-primary" size="large" onClick={() => window.Intercom && window.Intercom('show')}>
          <Trans i18nKey="core:template_error_contact_button" />
        </Button>
      )}
    </div>
  </div>
);

export default withTranslation()(ErrorComponent);
